import path from 'path';

import { Navigate, RouteObject } from 'react-router-dom';

import { pagePathSegments, queryParameters } from '~constants';
import { AccessPageLayout } from '~features/access';
import { PageLayout } from '~layouts';
import i18n from '~lib/i18n';
import {
	AccessLogsPage,
	AccessRuleDetailsPage,
	AccessRulesPage,
	AccessScheduleDetailsPage,
	AccessSchedulesPage,
	SkcDeviceGroupDetailsPage,
	SkcDeviceGroupsPage,
	SkcNfcTagsPage,
	SkcUserGroupDetailsPage,
	SkcUserGroupsPage,
} from '~pages';

const skcAccessRoutes = (): RouteObject[] => [
	{
		path: pagePathSegments.Access,
		element: (
			<AccessPageLayout
				pages={[
					{ i18nKey: 'rules', path: pagePathSegments.Rules },
					{ i18nKey: 'deviceGroups', path: pagePathSegments.DeviceGroups },
					{ i18nKey: 'accessGroups', path: pagePathSegments.AccessGroups },
					{ i18nKey: 'accessTags', path: pagePathSegments.AccessTags },
					{ i18nKey: 'schedules', path: pagePathSegments.Schedules },
					{ i18nKey: 'logs', path: pagePathSegments.Logs },
				]}
				persistedSearchParamKeys={[queryParameters.Organisation, queryParameters.PageSize]}
				slotProps={{
					header: {
						i18nTitleKey: 'nav.category.accessManagement',
					},
				}}
			/>
		),
		children: [
			{
				index: true,
				element: <Navigate to={pagePathSegments.Rules} />,
			},
			{
				path: pagePathSegments.Rules,
				element: <AccessRulesPage />,
			},
			{
				path: pagePathSegments.Logs,
				element: <AccessLogsPage />,
			},
			{
				path: pagePathSegments.DeviceGroups,
				element: <SkcDeviceGroupsPage />,
			},
			{
				path: pagePathSegments.AccessGroups,
				element: <SkcUserGroupsPage />,
			},
			{
				path: pagePathSegments.AccessTags,
				element: <SkcNfcTagsPage />,
			},
			{
				path: pagePathSegments.Schedules,
				element: <AccessSchedulesPage />,
			},
		],
	},
	{
		// Wrap the details pages separately, so that we can hide the navbar.
		path: pagePathSegments.Access,
		children: [
			{
				path: path.join(pagePathSegments.Rules, ':id'),
				element: (
					<PageLayout
						slotProps={{ header: { i18nTitleKey: 'views.addTemplate.templateDetails.title' } }}
					/>
				),
				children: [
					{
						index: true,
						element: <AccessRuleDetailsPage />,
					},
				],
			},
			{
				path: path.join(pagePathSegments.AccessGroups, ':id'),
				element: <PageLayout slotProps={{ header: { i18nTitleKey: 'accessGroupDetails' } }} />,
				children: [
					{
						index: true,
						element: <SkcUserGroupDetailsPage />,
					},
				],
			},
			{
				path: path.join(pagePathSegments.DeviceGroups, ':id'),
				element: <PageLayout slotProps={{ header: { i18nTitleKey: 'deviceGroupDetails' } }} />,
				children: [
					{
						index: true,
						element: <SkcDeviceGroupDetailsPage />,
					},
				],
			},
			{
				path: path.join(pagePathSegments.Schedules, ':id'),
				element: <PageLayout slotProps={{ header: { i18nTitleKey: 'scheduleDetails' } }} />,
				children: [
					{
						index: true,
						element: <AccessScheduleDetailsPage />,
					},
				],
			},
		],
	},
];

export default skcAccessRoutes;
